import { OpenNewTabTargetType } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { isFromAndroidWebview, isMobile, partnerNavigate } from '../../configs/utils';
import { Platform } from 'react-native';
import { sideBarNavigate } from "./utils";
import { ConnectionTypes, DeepLinks } from '../../configs/config';
const _isMobile = isMobile();
let date1 = '', date2 = '';
export const TestAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** Test Action Triggered ****', action);
    if (action.type === ACTION.VALIDATE_FORM_1) {
        date1 = action.payload.value;
    }
    if (action.type === ACTION.VALIDATE_FORM_2) {
        date2 = action.payload.value;
    }
};
export const onChangeTab = async (action, _datastore, standardUtilites) => {
    console.warn('**** onChangeTab Action Triggered 1 ****', action);
    await sideBarNavigate(standardUtilites, action);
};
export const RegisterClient = async (action, _datastore, { navigate, goBack, instrumentTrack }) => {
    instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** RegisterClient Action Triggered ****', action);
    navigate(ROUTE.REGISTER_LEADS);
};
export const InviteClient = async (action, _datastore, { navigate, goBack, instrumentTrack }) => {
    instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** InviteClient Action Triggered ****', action);
    const link = action.payload.link;
    navigate(ROUTE.INVITE_CLIENT, { _link: link, routeId: ROUTE.PARTNER_DASHBOARD_V2 });
};
export const goToMarketing = async (action, _datastore, utilities) => {
    console.warn('**** goToMarketing Action Triggered ****', action);
    await sideBarNavigate(utilities, action);
};
export const onLogoutPress = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onLogoutPress Action Triggered ****', action);
    navigate(ROUTE.PARTNER_LOGOUT);
};
export const promoBannerInvite = async (action, _datastore, { navigate }) => {
    await partnerNavigate(ROUTE.COLLATERAL);
};
export const onKnowMore = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("INVITE_PARTNER_BANNER_CTA_CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await partnerNavigate(ROUTE.PARTNER_REFERRED_PARTNER);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
export const goToAccountDetails = async (action, _datastore, utilities) => {
    console.warn('**** goToAccountDetails leads Action Triggered ****', action);
    await sideBarNavigate(utilities, action);
};
export const handleConnection = async (action, _datastore, { openNewTab }) => {
    try {
        const partnerDetail = action?.payload?.partnerDetail;
        let updatedPartnerDetail = `91${action?.payload?.partnerDetail}`;
        const type = action?.payload?.type;
        if (Platform.OS === 'web') {
            if (isFromAndroidWebview) {
                if (type === ConnectionTypes.GROUP_WHATSAPP)
                    window.open(partnerDetail, OpenNewTabTargetType.blank);
                else if (type === ConnectionTypes.CALL) {
                    window.open(DeepLinks.CALL + updatedPartnerDetail?.slice(2), OpenNewTabTargetType.parent);
                }
                else if (type === ConnectionTypes.WHATSAPP)
                    window.open(DeepLinks.WHATSAPP + updatedPartnerDetail, OpenNewTabTargetType.blank);
            }
            else {
                if (type === ConnectionTypes.WHATSAPP)
                    openNewTab(DeepLinks.WHATSAPP + updatedPartnerDetail, OpenNewTabTargetType.blank);
                else if (type === ConnectionTypes.CALL) {
                    openNewTab(DeepLinks.CALL + updatedPartnerDetail, OpenNewTabTargetType.parent);
                }
            }
        }
    }
    catch (error) {
        console.log(error, 'err');
    }
};
